import { v2Colors, breakpoints } from '@web-for-marketing/react-ui';

export const blogCard2Styles = {
    cardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        '&:focus-within': {
            outline: `1px solid ${v2Colors.border.activePrimary}`,
            outlineOffset: '3px',
            borderRadius: '0.8rem',
        },
        '&:hover img': {
            transform: 'scale(1.05)',
        },
    },
    imageWrapper: {
        width: '25rem',
        height: '16rem',
        borderRadius: '8px',
        overflow: 'hidden',
        flexShrink: 0,
        [`@media (max-width: ${breakpoints.sm})`]: {
            width: '10rem',
            height: '10rem',
        },
    },
    cardContent: (hasCategoryPill?: boolean) =>
        ({
            padding: '1.6rem 2.4rem',
            [`@media (max-width: ${breakpoints.sm})`]: {
                padding: hasCategoryPill ? '0 1.6rem' : '1.6rem',
            },
        }) as const,
    categoryMargins: {
        margin: '0 0 8px 0',
        [`@media (max-width: ${breakpoints.sm})`]: {
            margin: '0 0 4px 0',
        },
    },
    textTruncate: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    title: {
        marginBottom: '0.8rem',
        '&:hover': {
            color: v2Colors.text.activePrimary,
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            fontSize: '1.6rem',
            marginBottom: '0.4rem',
        },
    },
    titleMargin: {
        marginTop: '1.6rem',
    },
} as const;
